import { z } from "zod";
import { tokenAliasOrValue } from "./base";
import { DimensionUnit } from "./dimension";

export const ZIndexUnit = z.enum(["Raw"]);

export const ZIndexValue = z.object({
  unit: DimensionUnit,
  measure: z.number(),
});

export const ZIndexTokenData = tokenAliasOrValue(ZIndexValue);

export type ZIndexUnit = z.infer<typeof ZIndexUnit>;
export type ZIndexValue = z.infer<typeof ZIndexValue>;
export type ZIndexTokenData = z.infer<typeof ZIndexTokenData>;
